import { ILineString } from '@sparelabs/geography'
import { IListModelQueryParamValues } from '@sparelabs/http-client-utils'

export enum WayOverrideAction {
  Include = 'include',
  Exclude = 'exclude',
}

export interface IWayOverridePostBody {
  osmWayId: string
  action: WayOverrideAction
  geometry: ILineString
}

export interface IWayOverridePatchBody extends Partial<IWayOverridePostBody> {}

export interface IWayOverrideResponse extends IWayOverridePostBody {
  id: string
  createdAt: number
  updatedAt: number
}

export interface IListWayOverrideQueryParams extends IListModelQueryParamValues {}
